
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|2381|3678|4743|4855|8614)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
